import type {Voice} from "@khan/guide-types";

// sync-start:guide-voices 137115353 https://github.com/Khan/webapp/blob/master/services/ai-guide/speech/voice.go
// sync-start:guide-voices 137115353 https://github.com/Khan/webapp/blob/master/libs/guide-core/src/internal/audio-samples.ts
export const guideVoices: ReadonlyArray<Voice> = [
    "lmnt:khanmigo-m-1",
    "lmnt:khanmigo-f-2",
    "lmnt:khanmigo-nb-2",
];
// sync-end:guide-voices
